import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MultiCountryCurrencyModule } from "../../pipes/multi-country-currency/multi-country-currency.module";
import { BolivarDigitalButtonModule } from "../bolivar-digital-button/bolivar-digital.module";
import { ButtonModule } from "../button/button.module";
import { FavoritesButtonModule } from "../favorites-button/favorites-button.module";
import { PrimePetalLongModule } from "../prime-petal-long/prime-petal-long.module";
import { ProductImageModule } from "../product-image/product-image.module";
import { ProductPetalModule } from "../product-petal/product-petal.module";
import { ProductQuantityControlsModule } from "../product-quantity-controls/product-quantity-controls.module";
import { FlashOfferComponent } from "./flash-offer.component";

@NgModule({
  declarations: [FlashOfferComponent ],
  exports: [FlashOfferComponent ],
  imports: [
    CommonModule,
    RouterModule,
    MultiCountryCurrencyModule,
    ProductImageModule,
    ProductPetalModule,
    ProductQuantityControlsModule,
    ButtonModule,
    FavoritesButtonModule,
    BolivarDigitalButtonModule,
    PrimePetalLongModule
  ],
})
export class FlashOfferModule { }